import * as _ from 'lodash';

export interface AppSyncError {
  data: any;
  errorInfo: any;
  errorType: string;
  locations: any;
  message: string;
  path: string[];
}

export interface AppSyncResult {
  data: any;
  errors: AppSyncError[];
}

export class AppSyncErrorService {
  getMessage(err: AppSyncResult): string {
    if (!err || _.isEmpty(err.errors)) { return ''; }
    const msg = err.errors[0].message;
    if (msg.includes('UsernameExistsException')) {
      return 'Il existe déjà un compte avec cet email';
    } else if (msg.includes('AccessDeniedException')) {
        return 'Vous n\'êtes pas autorisé à effectuer cette opération';            
    }
    return msg;
  }
}
